<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
        >
          <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('companies.group_company_data')}}</h3>
          <div class="lg:max-w-detail lg:mr-auto" v-if="(role === 7 || role === 8 || role === 3)">
            <div class="lg:mb-2" >
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
              <div class="flex justify-between">
                <el-form-item prop="clienteId" class="w-full">
                  <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" clearable filterable disabled />
                </el-form-item>
                <base-button class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>
          </div>
          <div class="lg:max-w-detail lg:mr-auto">

            <div v-if="form.PersonaFisica">
              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
                  <el-form-item prop="PersonaFisicaNombre">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      v-model="form.PersonaFisicaNombre"
                      maxlength='40'
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('persons_data.firstsurname')}}</label>
                  <el-form-item prop="PersonaFisicaPriApellido">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      v-model="form.PersonaFisicaPriApellido"
                      maxlength='40'
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('persons_data.secondsurname')}}</label>
                  <el-form-item prop="PersonaFisicaSegApellido">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      v-model="form.PersonaFisicaSegApellido"
                      maxlength='40'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.companyName')}}</label>
                  <el-form-item prop="NombreCIF">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      v-model="form.NombreCIF"
                      maxlength='130'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.cif')}}</label>
                <el-form-item prop="CIF">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.CIF"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.telefono')}}</label>
                <el-form-item prop="Telefono" ref="Telefono">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.Telefono"
                    maxlength='15'
                  />
                </el-form-item>
              </div>
            </div>
            
            <div class="lg:mb-4">
              <el-switch class="switch-text break-normal" disabled v-model="form.Activo" :active-text="$t('app.active')"></el-switch>
            </div>


            <div class="flex items-center mt-6 mb-4">
              <h3 class="dark:text-darkblue-200 font-bold">{{$t('address.header')}}</h3>
              <!-- <base-tooltip-icon size="sm" :content="extensionTooltipDatosDireccion" class="ml-2 "/> -->
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.location')}}</label>
                <el-form-item prop="Direccion" ref="Direccion">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.Direccion"
                    maxlength='80'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.codigo_postal')}}</label>
                <el-form-item prop="CodigoPostal" ref="CodigoPostal">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.CodigoPostal"
                    maxlength='9'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.poblacion')}}</label>
                <el-form-item prop="Poblacion" ref="Poblacion">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.Poblacion"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.provincia')}}</label>
                <el-form-item prop="Provincia" ref="Provincia">
                  <el-input v-if="!isSpain"
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.Provincia"
                    maxlength='20'
                  />
                  <el-select v-else
                    class="w-full" 
                    v-model="form.Provincia" 
                    filterable
                    clearable 
                    :placeholder="$t('app.select')"
                    disabled>
                    <el-option
                      v-for="opt in listProvincias"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.pais')}}</label>
                <el-form-item prop="Pais" ref="Pais">
                  <base-el-select class="w-full" :options="listPaises" v-model="form.Pais" clearable filterable disabled />
                </el-form-item>
              </div>
            </div>
            
            <base-collapsible-form ref="baseCollapsibleRegistrationData"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.RegistrationData')}}</h4>
              </template>
              <template slot="content">
                <div class="flex flex-col md:flex-row items-center gap-x-2">  
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Book') }}</label>
                    <el-form-item prop="Book">
                      <el-input
                        clearable
                        disabled
                        class="w-full"
                        v-model="form.Book"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.RegisterOfCompaniesLocation') }}</label>
                    <el-form-item prop="RegisterOfCompaniesLocation">
                      <el-input
                        clearable
                        disabled
                        class="w-full"
                        v-model="form.RegisterOfCompaniesLocation"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Sheet') }}</label>
                    <el-form-item prop="Sheet">
                      <el-input
                        clearable
                        disabled
                        class="w-full"
                        v-model="form.Sheet"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Folio') }}</label>
                    <el-form-item prop="Folio">
                      <el-input
                        clearable
                        disabled
                        class="w-full"
                        v-model="form.Folio"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Section') }}</label>
                    <el-form-item prop="Section">
                      <el-input
                        clearable
                        disabled
                        class="w-full"
                        v-model="form.Section"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Volume') }}</label>
                    <el-form-item prop="Volume">
                      <el-input
                        clearable
                        disabled
                        class="w-full"
                        v-model="form.Volume"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.additional_data') }}</label>
                  <el-form-item prop="AdditionalData">
                    <el-input
                      clearable
                      disabled
                      class="w-full"
                      v-model="form.AdditionalData"
                      maxlength='20'
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form 
              ref="baseCollapsibleAlerts" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('avisos.header')}}</h4>
              </template>
              <template slot="content">

                <div class="mt-2 mb-4">
                    <div >
                      <el-switch class="switch-text break-normal" disabled v-model="form.EnviarAvisos" :active-text="$t('app.active')"></el-switch>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_emitida')}}</label>
                      <el-form-item prop="EmailAvisoNuevaEmitida" ref="EmailAvisoNuevaEmitida">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model="form.EmailAvisoNuevaEmitida"
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_recibida')}}</label>
                      <el-form-item prop="EmailAvisoNuevaRecibida" ref="EmailAvisoNuevaRecibida">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model="form.EmailAvisoNuevaRecibida"
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_cambio_estado')}}</label>
                      <el-form-item prop="EmailAvisoCambioEstado" ref="EmailAvisoCambioEstado">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model="form.EmailAvisoCambioEstado"
                        />
                      </el-form-item>
                    </div>
                  </div>

                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tech')}}</label>
                      <el-form-item prop="EmailTecnico">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model="form.EmailTecnico"
                          maxlength='500'
                        />
                      </el-form-item>
                    </div>
                  </div>

              </template>
            </base-collapsible-form>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="check"
            @click="deleteCompany()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="check"
            @click="restoreCompany()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <Dialog
        :title="$t('companies.delete_company')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template> 
      </Dialog>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getCompany } from '@/services/companies/getCompany'
// import { getCertificateFromCif } from '@/services/companies/getCertificateFromCif'
import { getClients } from '@/services/clients/getClients'
import moment from 'moment'
import { i18n } from '@/i18n'
import { deleteTrashCompany } from '@/services/trash/deleteTrashCompany'
import { restoreTrashCompany } from '@/services/trash/restoreTrashCompany'
import { Dialog } from 'element-ui'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-empresa',
  components: {
    DetailLayoutFullWidth,
    Dialog
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      vuexnamespace: 'companies',
      clientes: [],
      header: {
        title: i18n.t('trash.company_detail'),
        icon: 'companies',
        breadcrumb: {},
        nav: [],
        url: 'trash/companies'
      },
      form: {
        IdCIFEmpresa: 0,
        IdEmpresa: 0,
        CIF: '',
        NombreCIF: '',
        Activo: true,
        EmailTecnico: '',
        EmailAvisoNuevaEmitida: '',
        EmailAvisoNuevaRecibida: '',
        EmailAvisoCambioEstado: '',
        FechaAlta: '',
        FechaBaja: '',
        clienteId: '',
        EnviarAvisos: true,

        PersonaFisica: false,
        PersonaFisicaNombre: null,
        PersonaFisicaPriApellido: null,
        PersonaFisicaSegApellido: null,
        Telefono: null,
        Direccion: null,
        CodigoPostal: null,
        Poblacion: null,
        Provincia: null,
        Pais: 'ESP',

        Book: '',
        RegisterOfCompaniesLocation: '',
        Sheet: '',
        Folio: '',
        Section: '',
        Volume: '',
        AdditionalData: '',
      },
      certificate: null,
      showModal: false,
      processMessage: i18n.t('app.delete_permanent_current_confirmation_f', { entity: i18n.tc('companies.entity_name', 1).toLowerCase() }),
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    isSpain: function () {
      return this.form.Pais.toUpperCase() === 'ESP'
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    listProvincias: function () {
      return this.$store.getters['config/PROVINCIAS']
    },  
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const companyId = this.$route.params.id
    const breadcrumbs = []
    
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
    }

    await this.downloadCompanyData(companyId)
    breadcrumbs.push({ path: 'trash/companies', name: i18n.t('trash.header') })
    breadcrumbs.push({ path: 'trash/companies', name: i18n.t('trash.companies') })
    breadcrumbs.push({ path: '', name: this.form.NombreCIF })
    this.$store.commit('app/setheaderBreadCrumb', this.form.NombreCIF)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    deleteCompany () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idCifsEmpresa: []
        }
        payload.idCifsEmpresa.push(this.id)
        const response = await deleteTrashCompany(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreCompany: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idCifsEmpresa: []
        }
        payload.idCifsEmpresa.push(this.id)
        const response = await restoreTrashCompany(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    watchFormHandler: function ({ certificate, send_alerts }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    goBack: function () {
      this.$router.push({ name: 'trash/companies' })
    },
    downloadCompanyData: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          idCIFEmpresa: companyId,
          borrado: true,
        }
        const company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', company))
        } else {
          this.setCompany(company.CIFEmpresa)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCompany: function (company) {
      if (company) {
        this.form.NombreCIF = company.RazonSocial ? company.RazonSocial : null
        this.form.CIF = company.CIF ? company.CIF : null
        this.form.EmailTecnico = company.EmailTecnico ? company.EmailTecnico : null
        this.form.EmailAvisoNuevaEmitida = company.EmailAvisoNuevaEmitida ? company.EmailAvisoNuevaEmitida : null
        this.form.EmailAvisoNuevaRecibida = company.EmailAvisoNuevaRecibida ? company.EmailAvisoNuevaRecibida : null
        this.form.EmailAvisoCambioEstado = company.EmailAvisoCambioEstado ? company.EmailAvisoCambioEstado : null
        this.form.FechaAlta = company.FechaAlta ? company.FechaAlta : null
        this.form.FechaBaja = company.FechaBaja ? moment(company.FechaBaja).format('DD-MM-YYYY HH:mm') : null
        this.form.EnviarAvisos = company.EnviarAvisos
        this.form.Activo = company.Activo
        this.form.clienteId = company.idCliente ? company.idCliente : null
        this.form.CN = company.CN ? company.CN : null
        
        this.form.PersonaFisica = company.PersonaFisica ? company.PersonaFisica : null
        this.form.PersonaFisicaNombre = company.PersonaFisicaNombre ? company.PersonaFisicaNombre : null
        this.form.PersonaFisicaPriApellido = company.PersonaFisicaPrimerApellido ? company.PersonaFisicaPrimerApellido : null
        this.form.PersonaFisicaSegApellido = company.PersonaFisicaSegundoApellido ? company.PersonaFisicaSegundoApellido : null
        this.form.Telefono = company.Telefono ? company.Telefono : null

        this.form.Direccion = company.Direccion ? company.Direccion : null
        this.form.CodigoPostal = company.CodigoPostal ? company.CodigoPostal : null
        this.form.Poblacion = company.Poblacion ? company.Poblacion : null
        this.form.Provincia = company.Provincia ? company.Provincia : null
        this.form.Pais = company.CodigoPais ? company.CodigoPais : null

        this.form.Book = company.RegistroLibro ? company.RegistroLibro : null
        this.form.RegisterOfCompaniesLocation = company.RegistroRegistroMercantil ? company.RegistroRegistroMercantil : null
        this.form.Sheet = company.RegistroHoja ? company.RegistroHoja : null
        this.form.Folio = company.RegistroFolio ? company.RegistroFolio : null
        this.form.Section = company.RegistroSeccion ? company.RegistroSeccion : null
        this.form.Volume = company.RegistroTomo ? company.RegistroTomo : null
        this.form.AdditionalData = company.RegistroDatosAdiccionales ? company.RegistroDatosAdiccionales : null
      }
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-height: 100%;
}

</style>

<style lang="sass" scoped>
</style>
